import React from "react"
import styled from "styled-components"
import {
  GiWoodCabin,
  GiSeaCreature,
  GiForest,
  GiModernCity,
} from "react-icons/gi"

const Left = () => {
  return (
    <Wrapper>
      <h3>Chaica, Carretera Austral</h3>
      <p>
        <span>
          <GiWoodCabin />
        </span>
        Cabaña amoblada y tinaja.
      </p>
      <p>
        <span>
          <GiSeaCreature />
        </span>
        Vista y acceso al mar.
      </p>
      <p>
        <span>
          <GiForest />
        </span>
        Gran jardin
      </p>
      <p>
        <span>
          <GiModernCity />
        </span>
        A 20 minutos de Puerto Montt
      </p>
    </Wrapper>
  )
}

export default Left

const Wrapper = styled.div`
  h3 {
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3em;
  }
  svg {
    color: var(--primary-500);
    margin-right: 1rem;
    font-size: 1.2rem;
  }
  @media screen and (min-width: 768px) {
    width: 35%;
  }
`
